// ##### 24-05-22 Komarov: компонент с элементом для отображения условных обозначений точек на иконках в элементах Autocomplete
// ##### 25-05-02 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import AvailableNowSign from '../../../../Library/Icons/availableNowSign';
import OnRequestSign from '../../../../Library/Icons/onRequestSign';
// ##### Komarov 2025-08-05
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-21
const HotelsCitiesAvailabilityHint = ({ switcherRef }) => {
  const availableNow = useLocalizedText('Available_Now');
  const onRequest = useLocalizedText('Available_OnRequest');
  if (!switcherRef?.current) return null;
  // const space = parse("&nbsp;");

  return (
    <>
      <div style={{ display: 'flex' }}>
        <AvailableNowSign /> &nbsp; {availableNow}
      </div>
      <div style={{ display: 'flex' }}>
        <OnRequestSign /> &nbsp; {onRequest}
      </div>
    </>
  );
};

export default HotelsCitiesAvailabilityHint;
